<template>
  <div :class="classObj" class="app-wrapper">
    <div :class="{'fixed-header':fixedHeader}">
      <NavbarAgent v-if="userType=='agent'" />
      <navbar v-else />
    </div>
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside" />
    <agentSidebar v-if="userType=='agent'" class="sidebar-container" />
    <sidebar v-else class="sidebar-container" />
    <div :class="{hasTagsView:needTagsView}" class="main-container" style="padding-top: 48px">
      <app-main />
      <!-- <el-dialog class="examplesModalDialog2" style="z-index: 9999;font-size: 26px;" :visible.sync="$store.state['zsm-dict'].examplesModal" @close="$store.state['zsm-dict'].examplesModal=false">
        <img width="100%" :src="$store.state['zsm-course'].examplesImage" alt="">
      </el-dialog> -->
      <qustionInfo />
      <feedbackInfo />
    </div>
    <el-dialog v-if="userType!='agent'" class="sliderUserInfo" title="" :modal="false" :visible.sync="$store.state['zsm-user'].sliderUserInfo" width="360px">
      <div class="userInfo">
        <div class="userInfoT flex">
          <img v-if="userInfo.avatar&&userInfo.avatar!=''" :src="userInfo.avatar" alt="">
          <img v-else src="../static/daoshi.png" alt="">
          <div>
            <div>{{ userInfo.name }}</div>
            <span>{{ userInfo.mobile }}</span>
          </div>
        </div>
        <div class="userInfoB">
          <div>
            <div>联系人：</div>
            <span>{{ userInfo.realName }}</span>
          </div>
          <div>
            <div>联系电话：</div>
            <span>{{ userInfo.mobile }}</span>
          </div>
        </div>
        <div class="userInfoB">
          <div>
            <router-link to="/account/setting">
              <div @click="$store.state['zsm-user'].sliderUserInfo=false">设置</div>
            </router-link>
          </div>
        </div>
        <div class="userInfoB">
          <div>
            <router-link to="/pay">
              <div  @click="$store.state['zsm-user'].sliderUserInfo=false">账单和订阅方案</div>
            </router-link>
          </div>
        </div>
        <!-- <div class="userInfoB">
            <div>
              <router-link to="/pay">
                <div>建议改进</div>
              </router-link>
            </div>
          </div> -->
      </div>
      <div slot="footer">
        <div class="loginout pointer" @click="loginOut">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAKlBMVEVHcEwVFyMUGCAUFyMWGCIQECAVFyIVFyIUFiIWGCMVGCMVFyITFSMWGCMCCGxmAAAADXRSTlMA7yC53xCWcEuAX88w3Ch3MgAAAXtJREFUOMullLtKA0EUhtcNaxKNIDEXLBY2WNrYSyo7YWF9gICxshEM2Apb2QX0AQQfQBt7wdrKJZqL4X8Xz8yZa9xC9DQze77MmXP5J0HwH7vrlPvXgdtSsAZsl4It4P23oBqfWbDXsjfdY2JBHwvtrwNINIhgk7umfaZBSB8z9ocx/FAoEgk26TfPFuzT54EET8BHYkGYAnMJaNN06+gBS7HW6OilC6rkyGmtUCS/8pQvGQBfPqD027SMdVMNOOHbL4BTH9BgplzQgw82uOAX4NUHDU4nlo1yAfWxoIWyXh0tuwyo6yyUy4QKhruBGyrVlxtrcLNMusZUuqZAV3lTbkn7h/Lm3JmZD2hyn27bjam2m0EZ+alBiWY1XdDTIcZKDMqEGHhyFSUfZVY+QnD2iDigBCcl2tVgZCUqRY1j7t8VHFHTMyDrPGbR21DszDPgI9acJzpy/V2nprBv/ZPEG0Gq/cvcb1xNndnJVx9zdHMYF0fn2d//cb4BRjwkEHRO53oAAAAASUVORK5CYII="
            alt=""> 退出登录
        </div>
      </div>
    </el-dialog>
    <el-dialog v-else class="sliderUserInfo" title="" :modal="false" :visible.sync="$store.state['zsm-user'].sliderUserInfo" width="360px">
      <div class="userInfo">
        <div class="userInfoT flex">
          <img v-if="userInfo.avatar&&userInfo.avatar!=''" :src="userInfo.avatar" alt="">
          <img v-else src="../static/daoshi.png" alt="">
          <div>
            <div>{{ userInfo.name }}</div>
            <span>{{ userInfo.id }}</span>
          </div>
        </div>
        <div class="userInfoB">
          <div>
            <div>联系人：</div>
            <span>{{ userInfo.name }}</span>
          </div>
          <div>
            <div>代理商编号：</div>
            <span>{{ userInfo.id }}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="loginout pointer" @click="agentLoginOut">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAKlBMVEVHcEwVFyMUGCAUFyMWGCIQECAVFyIVFyIUFiIWGCMVGCMVFyITFSMWGCMCCGxmAAAADXRSTlMA7yC53xCWcEuAX88w3Ch3MgAAAXtJREFUOMullLtKA0EUhtcNaxKNIDEXLBY2WNrYSyo7YWF9gICxshEM2Apb2QX0AQQfQBt7wdrKJZqL4X8Xz8yZa9xC9DQze77MmXP5J0HwH7vrlPvXgdtSsAZsl4It4P23oBqfWbDXsjfdY2JBHwvtrwNINIhgk7umfaZBSB8z9ocx/FAoEgk26TfPFuzT54EET8BHYkGYAnMJaNN06+gBS7HW6OilC6rkyGmtUCS/8pQvGQBfPqD027SMdVMNOOHbL4BTH9BgplzQgw82uOAX4NUHDU4nlo1yAfWxoIWyXh0tuwyo6yyUy4QKhruBGyrVlxtrcLNMusZUuqZAV3lTbkn7h/Lm3JmZD2hyn27bjam2m0EZ+alBiWY1XdDTIcZKDMqEGHhyFSUfZVY+QnD2iDigBCcl2tVgZCUqRY1j7t8VHFHTMyDrPGbR21DszDPgI9acJzpy/V2nprBv/ZPEG0Gq/cvcb1xNndnJVx9zdHMYF0fn2d//cb4BRjwkEHRO53oAAAAASUVORK5CYII="
            alt=""> 退出登录
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import qustionInfo from './components/question/index'
  import feedbackInfo from './components/question/feedback'
  import RightPanel from '@/components/RightPanel'
  import {
    AppMain,
    Navbar,
    Settings,
    Sidebar,
    SidebarR,
    TagsView,
    agentSidebar,
    NavbarAgent
  } from './components'
  import ResizeMixin from './mixin/ResizeHandler'
  import {
    mapState
  } from 'vuex'
  import {
    getLocalStorage
  } from '@/utils/auth.js'
  export default {
    name: 'Layout',
    components: {
      feedbackInfo,
      qustionInfo,
      AppMain,
      Navbar,
      RightPanel,
      Settings,
      Sidebar,
      SidebarR,
      TagsView,
      agentSidebar,
      NavbarAgent
    },
    mixins: [ResizeMixin],
    computed: {
      ...mapState({
        agentSidebar: state => state.app.agentSidebar,
        sidebar: state => state.app.sidebar,
        device: state => state.app.device,
        showSettings: state => state.settings.showSettings,
        needTagsView: state => state.settings.tagsView,
        fixedHeader: state => state.settings.fixedHeader
      }),
      userType() { // 用户类型
        return getLocalStorage('user_type')
      },
      userInfo() {
        if (this.$store.state['zsm-user'].userInfo) {
          return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
        } else {
          return JSON.parse(JSON.parse(this.$store.state['zsm-user'].userInfo))
        }
      },
      activeMenu() {
        this.permission_routes = this.$route.matched[1].meta.childList
        this.title = this.$route.meta.title
        const route = this.$route
        return route.fullPath
      },
      classObj() {
        return {
          // hideSidebar: !this.sidebar.opened,
          // openSidebar: this.sidebar.opened,
          withoutAnimation: this.sidebar.withoutAnimation,
          mobile: this.device === 'mobile'
        }
      },
      childListLayout() {
        // if(this.$route)
      }
    },
    mounted() {},
    methods: {
      // 代理商退出
      agentLoginOut() {
        const that = this
        this.$confirm('退出知视猫创作者管理后台?', '提示', {
          confirmButtonText: '立即退出',
          cancelButtonText: '暂不退出',
          type: 'warning'
        }).then(() => {
          that.$store.dispatch('zsm-user/accountLogout', that.userInfo.id).then((res) => {
            that.$router.replace('/agent')
            that.$store.state['zsm-user'].sliderUserInfo = false
          })
        }).catch(() => {})
      },
      // 退出
      loginOut() {
        const that = this
        this.$confirm('退出知视猫创作者管理后台?', '提示', {
          confirmButtonText: '立即退出',
          cancelButtonText: '暂不退出',
          type: 'warning'
        }).then(() => {
          that.$store.dispatch('zsm-user/accountLogout', that.userInfo.mobile).then((res) => {
            that.$router.replace('/login')
          })
        }).catch(() => {})
      },
      handleClickOutside() {
        this.$store.dispatch('app/closeSideBar', {
          withoutAnimation: false
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .sliderUserInfo::v-deep {
    .el-dialog__footer {
      padding: 0;
      display: flex;
      align-items: center;
      height: 40px;
      background: rgba(22, 24, 35, .02) !important;
    }
    .loginout {
      color: rgba(22, 24, 35, .7);
      text-align: left;
      font-size: 14px;
      width: 200px;
      margin-left: 30px;
      position: relative;
      cursor: pointer;
      height: 40px;
      display: flex;
      align-items: center;
      line-height: 40px;
      img {
        margin-right: 6px;
        width: 16px;
        height: 16px;
      }
      /*  &::before {
            content: "";
            position: absolute;
            background: url();
            background-size: 100% 100%;
            width: 16px;
            height: 16px;
            top: 52%;
            -webkit-transform: translateY(-50%);
            transform: translateY(-50%);
            left: -24px;
          } */
    }
    .el-dialog {
      margin-left: 30px;
      margin-top: 110px !important;
    }
    .el-dialog__body {
      padding: 24px 32px;
      padding-top: 0;
    }
    .userInfoB {
      &>div {
        padding-top: 14px;
      }
      div {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        color: #161823;
        margin-bottom: 8px;
      }
      span {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        color: #161823;
      }
    }
    .userInfo {
      .userInfoT {
        display: flex;
        width: 100%;
        padding-bottom: 16px;
        border-bottom: 1px solid rgba(22, 24, 35, .06);
        img {
          width: 48px;
          height: 48px;
          margin-right: 8px;
          display: -webkit-box;
          display: flex;
          -webkit-box-align: center;
          align-items: center;
          border-radius: 50%;
        }
        &>div {
          div {
            font-family: PingFang SC;
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            width: 100%;
            color: #161823;
            margin-bottom: 4px;
            position: relative;
          }
          span {
            font-family: PingFang SC;
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: rgba(22, 24, 35, .5);
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  @import "~@/styles/mixin.scss";
  @import "~@/styles/variables.scss";
  /*.el-menu{*/
  /*  background: rgba(54, 54, 54, 1);*/
  /*}*/
  .examplesModalDialog2::v-deep {
    .el-icon-close {
      font-size: 26px;
    }
  }
  .main-container {
    height: 100vh;
    scrollbar-width: none!important;
    /* firefox */
    -ms-overflow-style: none!important;
    ;
    /* IE 10+ */
    overflow-x: hidden!important;
    ;
    overflow-y: auto!important;
    ;
    &::-webkit-scrollbar {
      display: none!important;
      ;
      /* Chrome Safari */
    }
  }
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }
  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }
  .mobile .fixed-header {
    width: 100%;
  }
</style>
